// extracted by mini-css-extract-plugin
export var label = "_el-5";
export var slideContainer = "_el-0";
export var slider = "_el-1";
export var sliderLg = "_el-4";
export var sliderMd = "_el-3";
export var sliderSm = "_el-2";